import { Grid, makeStyles, Theme, Typography, useTheme } from "@material-ui/core";
import React, { FunctionComponent } from "react";
import { IIconProps } from "../../../../assets/icons/icon";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    border: `2px solid ${theme.palette.grey["100"]}`,
    borderRadius: 16,
    padding: theme.spacing(4),
    height: "100%",
  },
  header: {
    paddingTop: theme.spacing(4),
    fontSize: 14,
    fontWeight: 300,
    whiteSpace: "break-spaces",
  },
  graphicContainer: {
    position: "relative",
    width: "40px",
    height: "40px",
    paddingBottom: theme.spacing(4),
  },
}));

interface IInfoBoxProps {
  icon: FunctionComponent<IIconProps>;
  text: string;
}

export const InfoBox: FunctionComponent<IInfoBoxProps> = (props) => {
  const theme = useTheme();
  const { icon, text } = props;
  const classes = useStyles();
  const IconComponent = icon;

  return (
    <Grid container className={classes.container} direction="column">
      <Grid item className={classes.graphicContainer}>
        <IconComponent fill={theme.palette.primary.main}></IconComponent>
      </Grid>
      <Grid item>
        <Typography className={classes.header}>{text}</Typography>
      </Grid>
    </Grid>
  );
};
